import React, { useEffect, useState } from 'react';
import ExcelJS from 'exceljs';
import { Select, Space, Button } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import { initializeB24Frame } from '@bitrix24/b24jssdk';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const App = () => {
  const [b24, setB24] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [selected, setSelected] = useState([]);
  const [excelUrl, setExcelUrl] = useState(null);
  const [isExcelLoading, setIsExcelLoading] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        // Инициализируем SDK
        const client = await initializeB24Frame();
        setB24(client);

        // Получаем склады
        const res = await client.callMethod('catalog.store.list');
        setWarehouses(res._data.result.stores || []);
      } catch (err) {
        console.error('Ошибка инициализации BX24 или получения складов:', err);
      }
    };

    init();
  }, []);

  const getAllProductsOnWarehouse = async (storeId) => {
    const all = [];
    let start = 0;

    while (true) {
      const res = await b24.callMethod('catalog.storeproduct.list', { filter: { storeId: storeId }}, start);
      const items = res._data.result.storeProducts || [];
      all.push(...items);
      if (!res._data.next) break;
      start = res._data.next;
    }

    return all;
  };

  const getProductDetailsBatch = async (ids) => {
    const results = [];
    for (let i = 0; i < ids.length; i += 50) {
      const batch = {};
      ids.slice(i, i + 50).forEach((id, idx) => {
        batch[`p${idx}`] = ['catalog.product.get', { id }];
      });
      const batchRes = await b24.callBatch(batch);
      for (const key in batchRes._data) {
        const r = batchRes._data[key];
        results.push({
          name: r.product.name || 'Ошибка получения'
        });
      }
    }
    return results;
  };

  const generateExcel = async () => {
    setIsExcelLoading(true);
    const wb = new ExcelJS.Workbook();

    for (const id of selected) {
      const store = warehouses.find(w => w.id === id);
      if (!store) continue;

      try {
        const products = await getAllProductsOnWarehouse(id);
        const infos = await getProductDetailsBatch(products.map(p => p.productId));

        const rows = infos.map((info, idx) => ({
          Название: info.name,
          Количество: products[idx]?.amount || 0
        }));

        const sheet = wb.addWorksheet(store.title || `Склад ${id}`);
        sheet.columns = [
          { header: 'Название', key: 'Название', width: 40 },
          { header: 'Количество', key: 'Количество', width: 15 },
        ];
        rows.forEach(r => sheet.addRow(r));
        sheet.eachRow(r => r.eachCell(c => {
          c.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
          c.alignment = { wrapText: true, vertical: 'middle', horizontal: 'left' };
        }));
      } catch (e) {
        console.error(`Ошибка при складе ${id}:`, e);
      }
    }

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    setExcelUrl(URL.createObjectURL(blob));
    setIsExcelLoading(false);
  };

  return (
    <Space direction="vertical" size="middle" style={{ padding: 20, display: 'flex' }}>
      <Select
        mode="multiple"
        allowClear
        style={{ width: 300 }}
        placeholder="Выберите склады"
        onChange={setSelected}
        options={warehouses.map(w => ({ label: w.title, value: w.id }))}
      />
      <Button type="primary" disabled={!selected.length} onClick={generateExcel}>
        Сформировать Excel
      </Button>
      {isExcelLoading ? (
        <LoadingOutlined />
      ) : (
        excelUrl && <a href={excelUrl} download="sklad.xlsx">Скачать файл</a>
      )}
    </Space>
  );
};

export default App;